import { Sorting } from 'src/common/components/Filters/constants/sorting';
import { RSimFilters } from '../constants/rsim';

type RSimProductsFiltersWithSorting = RSimFilters & {
  sorting: { columnName: string; sort: Sorting } | null;
};

type RSimProductsFiltersWithSortingAndPagination = RSimProductsFiltersWithSorting & {
  page?: number;
  rowsPerPage?: number;
};

export const rSimProductsQueries = {
  all: ['RSimProducts'],

  list: (filters?: RSimProductsFiltersWithSortingAndPagination) => {
    const baseListQueryKey = [...rSimProductsQueries.all, 'list'];

    if (!filters) {
      return baseListQueryKey;
    }

    const { sorting, tags, ...otherFilters } = filters;
    const sortingFilter = sorting || {};

    return [
      ...baseListQueryKey,
      {
        ...sortingFilter,
        tags: tags ? [...tags].sort((a, b) => a.localeCompare(b)) : null,
        ...otherFilters,
      },
    ];
  },
  pagination: (filters: RSimProductsFiltersWithSortingAndPagination) => {
    const [allKey, listKey] = rSimProductsQueries.list(filters);
    return [allKey, 'Pagination', listKey, filters];
  },
  export: (filters: RSimProductsFiltersWithSorting) => {
    return [...rSimProductsQueries.list(filters), 'Export'];
  },
  allSims: () => {
    return [...rSimProductsQueries.all, 'sims'];
  },
  sims: (props: { euiccs: string[] }) => {
    return [...rSimProductsQueries.all, 'sims', props];
  },
  enability: (props: { euiccs: string[] }) => {
    return [...rSimProductsQueries.all, 'Enability', props];
  },
  lastPollingTimestamps: (props: { euiccs: string[] }) => {
    return [...rSimProductsQueries.all, 'RsimProductsLastPollingTimestamps', props];
  },
  availableActions: (filters: { euiccs: string[] }) => [
    ...rSimProductsQueries.all,
    'availableActions',
    filters,
  ],
};
